import React from 'react';
import {Modal} from 'react-bootstrap';
import {assets} from '../../../../../utils/assetsSrc';
import {Form, Formik} from 'formik';
import * as Yup from 'yup';
import TextField from '../../../../../components/form/textfield/textfield';
import Button from '../../../../../components/form/button/button';
import './addDevice.scss';

export default function AddDevice({show, setShow, handleDeviceCreation}) {
  const initialValues = {
    name: '',
    contactCentre: '',
    contact: '',
  };

  const validate = Yup.object({
    name: Yup.string().trim().required('Name is Required'),
  });

  const handleSubmit = values => {
    handleDeviceCreation({
      name: values.name.trim(),
      contact_centre: values.contactCentre.trim(),
      contact: values.contact.trim(),
    });
  };

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      aria-labelledby="add-device"
      centered
      className="add-device">
      <Modal.Body className="p-5 px-5 text-center">
        <div className="header">
          <p className="label mt-3 mb-4">New Device</p>
          <img onClick={() => setShow(false)} src={assets.closeIcon} />
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={validate}
          onSubmit={handleSubmit}>
          {() => (
            <Form>
              <div className="add-device-row">
                <TextField
                  name="name"
                  type="text"
                  label="Device name"
                  placeholder="Name of Device"
                />
              </div>
              <div className="add-device-row">
                <TextField
                  name="contactCentre"
                  type="text"
                  label="Contact center"
                  placeholder="Contact center"
                />
              </div>
              <div className="add-device-row">
                <TextField
                  name="contact"
                  label="Contact"
                  placeholder="Contact name and email"
                  isMultiline
                />
              </div>
              <div className="action-buttons">
                <Button
                  type="button"
                  clickHandler={() => setShow(false)}
                  variant="secondary-button">
                  Cancel
                </Button>
                <Button type="submit" variant="submit-button">
                  Create
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}
